module.exports = __webpack_public_path__ + "static/media/tooltip_roundabout_straight.c7fa24d3.png";